import { useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import ReactApexChart from 'react-apexcharts';

import { Flex, Text } from '@chakra-ui/react';

import { apiService } from 'services/ApiService';

import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import RangeSelect from './RangeSelect';

import { createBarChartOptions } from './chartOptions';

function FuelLitersChart() {
  const [period, setPeriod] = useState('year');

  const { data: chart = [], isLoading } = useQuery({
    queryKey: ['fuel-liters-chart', period],
    refetchOnWindowFocus: false,
    retry: false,
    queryFn: async () => {
      const response = await apiService.getStatsFuelLiters({
        range: period,
      });

      return response.data;
    },
  });

  const series = useMemo(
    () => [
      {
        name: 'Fuel',
        data: chart.map((item) => item.count),
      },
    ],
    [chart],
  );

  const options = useMemo(
    () =>
      createBarChartOptions({
        color: '#BB4A02',
        categories: chart.map((item) => new Date(item.date).toISOString()),
        yFormatter: (value) => `${value.toFixed(0)} L`,
        tooltipFormatter: (value) => `${value.toFixed(2)} L`,
      }),
    [chart],
  );

  return (
    <Card minH={301} padding="24px 16px 12px 16px" w="100%">
      <Flex justifyContent="center" mb="12px">
        <Text variant="title-lg">Fuel Liters Sold</Text>
      </Flex>

      <RangeSelect period={period} setPeriod={setPeriod} />

      <CardBody w="100%" padding="0">
        {isLoading ? (
          <Text mt={6}>Loading chart data...</Text>
        ) : (
          <ReactApexChart
            options={options}
            series={series}
            type="bar"
            height={300}
            className="full-width-members-dashboard-chart"
          />
        )}
      </CardBody>
    </Card>
  );
}

export default FuelLitersChart;
